import { SvgIconProps } from 'ui/icons';
import { COMPONENT_TYPE } from './constants';
import { NoDataContainer, NoDataLink, NoDataSubTitle, NoDataTitle } from './Styled';

const KNOWLEDGE_BASE_URL =
  'https://support.iterable.com/hc/en-us/articles/205480325-Experiments-Overview-';

type NoDataProps = {
  testId: string;
  componentType: COMPONENT_TYPE;
  Icon: React.ComponentType<React.PropsWithChildren<SvgIconProps>>;
  title: string;
  subTitle: string;
  link?: string;
  onClick?: () => void;
  linkText?: string;
  postText?: string;
  newTabLink?: boolean;
};

export const NoData = ({
  componentType,
  Icon,
  title,
  subTitle,
  link = KNOWLEDGE_BASE_URL,
  onClick,
  linkText,
  testId,
  postText = '',
  newTabLink = true,
}: NoDataProps) => {
  const linkProps = onClick
    ? {
        onClick,
      }
    : {
        href: link,
        target: newTabLink ? '_blank' : '',
      };
  return (
    <NoDataContainer componentType={componentType} data-test={testId}>
      <Icon />
      <NoDataTitle componentType={componentType}>{title}</NoDataTitle>
      <NoDataSubTitle componentType={componentType}>
        {subTitle}
        {linkText && <NoDataLink {...linkProps}>{linkText}</NoDataLink>}
        {postText}
      </NoDataSubTitle>
    </NoDataContainer>
  );
};
